$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.module', ['ngSanitize', 'ngResource', 'ngAnimate', 'ui.router', 'common.backend', 'common.ui', 'templates', 'angular-google-analytics', 'dndLists', 'ngStorage', 'angular.filter']).config(function($stateProvider, $urlRouterProvider, $httpProvider, AnalyticsProvider) {
    var dataPromise = false;
    var moduleResolve = {
      organizerChannel: function(resolveChannel) {
        return resolveChannel('organizer');
      },
      moduleData: function($http, $q, ClassroomSettings) {
        if (!dataPromise) {
          dataPromise = $q.defer();
          var schoollevel = (ClassroomSettings.get().schoollevel ? '?schoolniveau=' + ClassroomSettings.get().schoollevel : '');
          var content = (typeof MODULE_JSON_API !== 'undefined' ? MODULE_JSON_API + schoollevel : '/module/content.json');
          $http.get(content).then(function(response) {
            dataPromise.resolve(response.data);
          });
        }
        return dataPromise.promise;
      }
    };
    $stateProvider.state('module', {
      title: 'Level',
      abstract: true,
      template: '<ui-view id="main"></ui-view>',
      resolve: moduleResolve,
      controller: 'ModuleCtrl'
    }).state('module.start', {
      title: 'Start',
      url: '/',
      templateUrl: "module/start.html",
      onEnter: function($state, moduleData, VoiceOver) {
        VoiceOver.stop();
        if (moduleData.voice_over && moduleData.start) {
          VoiceOver.play(moduleData.voice_over, function() {
            $rootScope.$broadcast('state', {state: 'done'});
          });
        }
        if (!moduleData.start) {
          $state.go('module.chapter.slide', {
            chapter: moduleData.chapters[0].id,
            slide: 1
          });
        }
      }
    }).state('module.chapter', {
      title: 'Chapter',
      url: '/:chapter',
      abstract: true,
      template: '<ui-view id="chapter" class="{{ chapter.slug }}"></ui-view>',
      controller: 'ChapterCtrl'
    }).state('module.chapter.slide', {
      url: '/:slide',
      templateUrl: "module/slide.html",
      controller: 'SlideCtrl'
    });
    ;
    $urlRouterProvider.otherwise("/");
  }).run(function(AudioManager, $rootScope, Analytics) {
    AudioManager.load();
    $rootScope.page = {setTitle: function(title) {
        this.title = title + ' | Jet-Net & TechNet Inspiratieles';
      }};
    $rootScope.$on('$stateChangeSuccess', (function(event, current, currentParams) {}));
  });
  ;
  return {};
});

